import ApiModel from 'models/api-model';
import {
  BALANCE_SHEET_WORKPAPER,
  INCOME_STATEMENT_WORKPAPER,
} from 'constants/feature/element-panel-constants';

export default class TrialBalanceTaggedElements extends ApiModel({
  data: {
    [BALANCE_SHEET_WORKPAPER]: false,
    [INCOME_STATEMENT_WORKPAPER]: false,
  },
}) {
  processResponse(response) {
    return this.merge({
      data: {
        [BALANCE_SHEET_WORKPAPER]: !!response?.data?.[BALANCE_SHEET_WORKPAPER],
        [INCOME_STATEMENT_WORKPAPER]:
          !!response?.data?.[INCOME_STATEMENT_WORKPAPER],
      },
    });
  }

  get hasTaggedElements() {
    return (
      this.data[BALANCE_SHEET_WORKPAPER] ||
      this.data[INCOME_STATEMENT_WORKPAPER]
    );
  }
}
